import {
  USER_INFO,
  MENU,
  PERM,
  ADER_SETTING,
  AD_SETTING,
  AFF_SETTING,
  CHANNEL_SETTING,
  FINANCE_SETTING,
  COUNTRIES,
  CARRIERS,
  ALL_CARRIERS,
  TIMEZONE,
  TIMEZONEV1,
  OFFER_SETTING,
  ROLE,
  INCLUDES,
  OS_SETTING,
  CODE_REASON,
  CRITICISM_REASON,
  RECOMMEND_TYPE,
  FORM_ORIGIN,
  ASO_ADER_SETTING,
} from './mutation-types'
import generateMenu from '../js/generateMenu'

export default {
  // ES6的计算属性
  [USER_INFO](state, { id, name, email, roles, is_superuser }) {
    state.user.id = id
    state.user.name = name
    state.user.email = email
    state.user.roles = roles
    state.user.is_superuser = is_superuser
  },
  [MENU](state, perm) {
    let permList = []
    for (let key in perm) {
      let details = perm[key]
      for (let k in details) {
        if (details[k] > 0) {
          permList.push(key + '.' + k.substr(4)) // substr(4)去掉前缀'can_' , #TODO 考虑后端统一一下，删掉这个前缀
        }
      }
    }
    state.permList = permList
    state.menu = generateMenu(permList, state.user.is_superuser)
  },
  [PERM](state, perm) {
    state.perm = perm
  },
  [ADER_SETTING](state, { ader }) {
    state.ader_setting = ader
  },
  [AD_SETTING](state, { offer }) {
    state.ad_setting = offer
  },
  [AFF_SETTING](state, data) {
    state.aff_setting = data.aff
  },
  [OS_SETTING](state, data) {
    state.os_setting = data.setting.app_name_os
  },
  [CHANNEL_SETTING](state, data) {
    state.channel_setting = data.channel
  },
  [FINANCE_SETTING](state, data) {
    state.finance_setting = data.finance
  },
  [COUNTRIES](state, data) {
    state.countries = data
  },
  [CARRIERS](state, { carriers, all_carriers }) {
    state.carriers = carriers
    state.all_carriers = all_carriers
  },
  [ALL_CARRIERS](state, { all_carriers }) {
    state.all_carriers = all_carriers
  },
  [TIMEZONE](state, data) {
    state.timezone = data
  },
  [TIMEZONEV1](state, data) {
    state.timezonev1 = data
  },
  [OFFER_SETTING](state, data) {
    state.offer_setting = data.offer
  },
  [ROLE](state, { role }) {
    state.role = role
  },
  [INCLUDES](state, data) {
    state.includes = data
  },
  [CODE_REASON](state, data) {
    state.code_reason = data
  },
  [CRITICISM_REASON](state, data) {
    state.criticism_reason = data
  },
  [RECOMMEND_TYPE](state, data) {
    state.recommend_type = data.finance.recommend_type
  },
  [FORM_ORIGIN](state, data) {
    state.form_origin = data
  },
  [ASO_ADER_SETTING](state, { ader }) {
    state.aso_ader_setting = ader
  },
}
